export default
{
	icons: [
		{
			name: "blinds",
			x: 1062,
			y: 315
		},
		{
			name: "clock",
			x: 1557,
			y: 89.25
		},
		{
			name: "whiteboard",
			x: 1683,
			y: 433.05
		},
		{
			name: "drip",
			x: 589,
			y: 318
		},
		{
			name: "breakfast",
			x: 284,
			y: 526
		},
		{
			name: "talk2pat",
			x: 416,
			y: 433.05
		},
		{
			name: "exit",
			x: 948,
			y: 950.05
		},
		{
			name: "zweedseBand",
			x: 563,
			y: 527.05
		},
		{
			name: "glasses",
			x: 324,
			y: 540
		},
		{
			name: "medication",
			x: 491,
			y: 480.5
		},
		{
			name: "water",
			x: 205.5,
			y: 502.5
		},
		{
			name: "shower",
			x: 711,
			y: 550.05
		},
		{
			name: "cad",
			x: 491,
			y: 705.05
		}
	],
	objects: [
		{
			name: "clock",
			x: 1521.15,
			y: 0
		},
		{
			name: "whiteboard",
			x: 1511,
			y: 512
		}
	]
}